import { DatePicker } from '@/primitives/DatePicker';
import { DateLocalizationProvider } from '@/providers/DateLocalizationProvider';
import { formatFilterDate, parseFilterDate } from './basicSearchConditionUtils';

export default function BasicSearchConditionDatePicker({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <DateLocalizationProvider>
      <DatePicker
        fieldDensity="compact"
        label={label}
        sx={{ flex: 1, minWidth: 0 }}
        value={parseFilterDate(value)}
        variant="filled"
        slotProps={{
          openPickerButton: {
            sx: { cursor: 'pointer' },
          },
          textField: {
            slotProps: {
              input: {
                sx: {
                  borderColor: 'grey.500',
                  cursor: 'pointer',
                  minHeight: '56px',
                  '& input, & .MuiPickersSectionList-root': {
                    cursor: 'pointer',
                  },
                  '& .MuiInputAdornment-root .MuiIconButton-root': {
                    cursor: 'pointer',
                  },
                },
              },
            },
          },
        }}
        onChange={(nextValue) => {
          onChange(
            formatFilterDate(nextValue instanceof Date ? nextValue : null),
          );
        }}
      />
    </DateLocalizationProvider>
  );
}
